module.exports = __webpack_public_path__ + "img/plus.10505e15.svg";